{
  "ResourceModal": {
    "title": "生成PDF",
    "managerTitle": "可用字段",
    "Instagram": "Instagram",
    "Twitter": "Twitter",
    "Behance": "Behance",
    "Youtube": "Youtube",
    "Vimeo": "Vimeo",
    "Website": "网站",
    "Email": "电子邮件",
    "Phone number": "电话号码",
    "Location": "位置",
    "Rate": "评分",
    "Tags": "标签",
    "Organization": "组织",
    "Agent": "代理",
    "Groups": "群组",
    "QR Code": "二维码",
    "Options": "选项"
  }
}
